import { Form } from '../entities/form';
import { FormRequest } from '../entities/form_request';
import { BaseOrganizationEndpoints } from './base';
import { ResponseWithStatus } from './response/response_with_status';

export class Forms extends BaseOrganizationEndpoints {
  async add(request: FormRequest): Promise<ResponseWithStatus<Form>> {
    return this.requestWithStatus<Form>('POST', `/forms`, request);
  }

  async form(id: string): Promise<ResponseWithStatus<Form>> {
    return this.requestWithStatus<Form>(
      'GET',
      `/forms/${encodeURIComponent(id)}`
    );
  }
}
